import { useQueryClient } from "@tanstack/react-query";
import React, { useState, useCallback } from "react";
import { archiveBoard } from "../../../../../services/apiBoards";
import { objectToFormData } from "../../../../../utils";
import { Tooltip, Typography } from "@mui/material";
import { TooltipName } from "../../../../../utils/Enums";
import FormDialog from "../../../../../components/Dialog/FormDialog";
import { useBoardMutationDialog } from "../../hooks/useBoardMutationDialog";

export const ArchiveBoard = React.memo(function ArchiveBoard({ isArchive, id }) {
  const [archiveStatus, setArchiveStatus] = useState(isArchive);
  const queryClient = useQueryClient();
  const archiveDialog = useBoardMutationDialog({
    apiFn: archiveBoard,
    invalidateKeys: ["boards"],
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["boardName", id],
      });
      setArchiveStatus((data) => !data);
    },
    onError: (error) => {
      console.error("Error Delete Attachments", error);
    },
  });

  const submitArchiveDialog = useCallback(() => {
    const data = objectToFormData({ is_archive: archiveStatus, board_id: id });
    archiveDialog.submit({ id, data });
  }, [archiveDialog, archiveStatus, id]);
  
  return (
    <div className="w-100 d-flex justify-content-center">
      <Tooltip
        title={
          isArchive
            ? TooltipName.MANAGE_BOARD.UNARCHIVE_THIS_BOARD
            : TooltipName.MANAGE_BOARD.ARCHIVE_THIS_BOARD
        }
      >
        <label className="switch">
          <input
            type="checkbox"
            value={archiveStatus}
            checked={archiveStatus}
            onChange={archiveDialog.openDialog}
          />
          <div className="slider"></div>
        </label>
      </Tooltip>
      {archiveDialog.isDialogOpen && (
        <FormDialog
          open={archiveDialog.isDialogOpen}
          handleClose={archiveDialog.closeDialog}
          handleSubmit={submitArchiveDialog}
          loading={archiveDialog.isSubmitting}
          buttonTxt={!isArchive ? "Restore" : "Archive"}
          title={
            !isArchive
              ? "Confirmation: Restore Board"
              : "Confirmation: Archive Board"
          }
          alignActions={"center"}
          cancelBtn={true}
          fullWidth={true}
        >
          <Typography className="align_text_center mb-2 ">
            {!isArchive
              ? "Are you sure you want to restore the board ?"
              : "Are you sure you want to archive this board? Archiving the board will hide it from view and move it to the archive section. You can always restore it later if needed. Please confirm your action."}
          </Typography>
        </FormDialog>
      )}
    </div>
  );
});
